export const LOGIN_OPS_URL = '/login'

export const ssnFormatedRegex = new RegExp(
  '^(?!666|000|9\\d{2})\\d{3}-(?!00)\\d{2}-(?!0{4})\\d{4}$'
)
export const ssnString = /^\d{9}$/

export const PROPERTY_USAGES = {
  'principal-residence': 'Residence',
  'second-home': '2nd Home',
  investment: 'Investment',
}

export const MIN_HOME_VALUE = 175_000

export const PR_REVIEW_STATUSES = {
  fast_track: 'Fast Track',
  parking_lot: 'Parking Lot',
}

export const HIDE_DTI_PRICING_VERSION = 21.0

export const PERIOD_LOOKUP = {
  weekly: 'Weekly',
  hourly: 'Hourly',
  bi_weekly: 'Bi-Weekly',
  semi_monthly: 'Semi-Monthly',
  monthly: 'Monthly',
  annual: 'Annual',
}

export const INCOME_TYPES_LOOKUP = {
  w2: 'W2',
  bco: 'Bonus, Commission or Overtime',
  rap: 'Retirement, Annuity or Pension',
  ss_vab_nti: 'Social Security, VA Benefits or Non-Taxable Income',
  self_bo: 'Self Employed (Business Owner)',
  self_sp: 'Self Employed (Sole Proprietor)',
}
